'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { ApiError } from '@/lib/api';

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // 1분
            refetchOnWindowFocus: true, // 탭 복귀 시 세션 갱신된 토큰으로 refetch
            retry: (failureCount, error) => {
              // 401/403 인증 에러는 재시도 불필요 (fetchAPI에서 이미 처리)
              if (error instanceof ApiError && (error.isUnauthorized() || error.isForbidden())) {
                return false;
              }
              return failureCount < 2;
            },
          },
          mutations: {
            retry: false,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
